import { Component } from "react";
import Axios from "axios";
import { COLLEAGUE_USER_TYPE } from "../../config/string";

class RedirectLogin extends Component {

    componentDidMount() {
        this.redirectUser();
    }

    redirectUser = () => {
        const queryParams = new URLSearchParams(this.props.location.search);
        if (queryParams.get('user_type') === COLLEAGUE_USER_TYPE) {
            console.log('Redirecting to Azure AD login');
            this.initiateAzureAdLogin();
        } else {
            console.log('Redirecting to Okta federated login');
            this.initiateOktaLogin();
        }
    }

    initiateOktaLogin = async () => {
        try {
            const response = await Axios.get('/cognito/auth-url');
            window.location.href = response.data.authUrl;
        } catch (error) {
            console.error('Failed to initiate Okta login', error);
        }
    }

    initiateAzureAdLogin = async () => {
        try {
            const response = await Axios.get('/otds/auth-url');
            window.location.href = response.data.authUrl;
        } catch (error) {
            console.error('Failed to initiate Azure login', error);
        }
    }

    render() {
        return null;
    }
}

export default RedirectLogin;